import history from "history.js";
import api, { globalErrorHandler } from "../Api";
import axios from "axios";
import { Store } from "../Store";
import {
  SET_USER_DATA,
  USER_LOGGED_OUT,
  GET_USER_BY_USERNAME,
  GET_ACCOUNT_BY_USERNAME,
  USER_LOADING,
} from './ActionTypes';

const config = {
  headers: {
      'content-type': 'multipart/form-data',
  }
};

let logoutInProgress = false;

export const setUserData = user => dispatch => {
  dispatch({
    type: SET_USER_DATA,
    data: user
  });
};

export function logoutUser() {
  return async dispatch => {
    if (logoutInProgress) return;
    logoutInProgress = true;
    try {
      const token = Store.getState().login?.token;
      if (token) {
        await api.delete(`/Authenticate`);
      }
    } catch (error) {
      if (error.response?.status !== 400) {
        console.error("Logout failed:", error);
      }
    } finally {
      logoutInProgress = false;
      dispatch({ type: USER_LOGGED_OUT });
      dispatch({ type: "LOGIN_CLEAR" });
      history.push("/session/signin");
    }
  };
}

export const updateUserData = (payload) => (dispatch) => {
  //console.log("entré",payload)
  var formData = new FormData();
  formData.append("email", payload.email);
  formData.append("phone", payload.phone);
  formData.append("badge", payload.badge);
 
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //console.log("formdata", formData)
  //api.post(`/GrowthOpportunityUser/UpdatePersonalInformation`, formData, config).then(res => {
  axios
    .post(
      `https://middleware.foundever.com/GOAPI/api/Employee/UploadEmployeeInfo`,
      {
        email: payload.email,
        phone: payload.phone,
        badge: payload.badge,
      },
      config
    )
    .then((res) => {
      setUserData(res.data);
    });
};

export const GetUserByUsername = (username) => {
  
  return async dispatch => {
    // dispatch({
    //   type: USER_LOADING
    // });
    await api.get(`/User/GetUserByUserName/${username}`,config).then(res => 
      dispatch({
        type: GET_USER_BY_USERNAME,
        data: res.data
        }),
        
      ).catch(globalErrorHandler); 
      
  };
};

export const GetAccountByUsername = (username) => {
  
  return async dispatch => {
    dispatch({
      type: USER_LOADING
    });
    await api.get(`/User/GetUserByUserName/${username}`,config).then(res => 
      dispatch({
        type: GET_ACCOUNT_BY_USERNAME,
        data: res.data
        }),
      ).catch(globalErrorHandler); 
  };
};